export const stationTypes={
    SET_DASHBOARD_STATIONS:'SET_DASHBOARD_STATIONS',
    SET_MAP_STATIONS:'SET_MAP_STATIONS',
    SET_MAP_ZOOM:'SET_MAP_ZOOM',
    SET_ALARMS:'SET_ALARMS',
}